import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientResetPasswordPage from "@/pages/client/ClientResetPasswordPage";

export const Route = createFileRoute("/client_/reset-password")({
  head: () => pageHead("Client Portal Password Reset", "Request or set a new Client Portal password.", "/client/reset-password", true),
  component: ClientResetPasswordPage,
});
